import React from "react";
import styles from './CaseLogCard.module.scss';
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {ReactComponent as ChevronRightIcon} from './ChevronRight.svg';
import {ReactComponent as FileTextIcon} from './FileText.svg';
import {ReactComponent as FileTextDeletedIcon} from './FileTextDeleted.svg';
import {ReactComponent as XIcon} from './X.svg';
import { toCamelCase } from "../../utils/stringUtils";

const CaseLogCard = ({
  data,
  cta,
  status,
  canDelete,
  onDelete
}) => {
  return (
    <div className={`${styles.card} ${styles[toCamelCase(status)] ?? ''}`}>
      {canDelete && <div className={styles.close}>
        <XIcon onClick={() => onDelete()}/>
      </div>}
      <div className={styles.content}>
        <div className={`${styles.icon} ${styles[toCamelCase(status)] ?? ''}`}>
          {status === 'Deleted' ? <FileTextDeletedIcon/> : <FileTextIcon />}
        </div>
        <table className={styles.dataTable}>
          <tbody>
            {data.map((item) => (
              <tr key={item.label}>
                <th>{item.label}</th>
                <td>{item.text}</td>
              </tr>
            ))}
            <tr>
              <th>Status</th>
              <td className={styles[toCamelCase(status)] ?? ''}>{status}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {cta && <div className={styles.cta}>
        <Link to={cta.link}>{cta.label}<ChevronRightIcon /></Link>
      </div>}
    </div>
  );
};

CaseLogCard.propTypes = {
  date: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      text: PropTypes.any,
    })
  ).isRequired,
  cta: PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired
  }),
  status: PropTypes.oneOf(['Incomplete', 'Submitted', 'Submitted Late', 'Past Due', 'Deleted']).isRequired,
  canDelete: PropTypes.bool,
  onDelete: PropTypes.func
}

export default CaseLogCard;